var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common common-form-inline" },
    [
      _c(
        "a-form-model",
        {
          ref: "vertifyForm",
          attrs: {
            model: _vm.pageData,
            rules: _vm.rules,
            "label-col": _vm.labelCol,
            "wrapper-col": _vm.wrapperCol
          }
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "原管理员姓名", prop: "realname" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.pageData.realname,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "realname", $$v)
                          },
                          expression: "pageData.realname"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: { label: "原管理员身份证", prop: "certificateNum" }
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.pageData.certificateNum,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "certificateNum", $$v)
                          },
                          expression: "pageData.certificateNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "原管理员电话", prop: "mobile" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.pageData.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "mobile", $$v)
                          },
                          expression: "pageData.mobile"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "新管理员姓名", prop: "newRealname" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.pageData.newRealname,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "newRealname", $$v)
                          },
                          expression: "pageData.newRealname"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "新原管理员身份证",
                        prop: "newCertificateNum"
                      }
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.pageData.newCertificateNum,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "newCertificateNum", $$v)
                          },
                          expression: "pageData.newCertificateNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "新管理员电话", prop: "newMobile" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.pageData.newMobile,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "newMobile", $$v)
                          },
                          expression: "pageData.newMobile"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "管理员身份证照片", prop: "file4510" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "spaceLeft",
                          staticStyle: { width: "600px" }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("imgUpload", {
                                attrs: {
                                  file: _vm.file4,
                                  paramObj: _vm.paramObj4,
                                  text: "正面",
                                  removeaction: true,
                                  name: "file"
                                },
                                on: {
                                  uploadOk: _vm.uploadOk,
                                  remove: function($event) {
                                    return _vm.removeFile($event, "file4")
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("imgUpload", {
                                attrs: {
                                  file: _vm.file5,
                                  paramObj: _vm.paramObj5,
                                  text: "反面",
                                  removeaction: true,
                                  name: "file"
                                },
                                on: {
                                  uploadOk: _vm.uploadOk,
                                  remove: function($event) {
                                    return _vm.removeFile($event, "file5")
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("imgUpload", {
                                attrs: {
                                  file: _vm.file10,
                                  paramObj: _vm.paramObj10,
                                  text: "管理员手持身份证照片",
                                  removeaction: true,
                                  name: "file"
                                },
                                on: {
                                  uploadOk: _vm.uploadOk,
                                  remove: function($event) {
                                    return _vm.removeFile($event, "file10")
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "授权委托书", prop: "file7" } },
                    [
                      _c(
                        "div",
                        [
                          _c("imgUpload", {
                            attrs: {
                              file: _vm.file7,
                              paramObj: _vm.paramObj7,
                              removeaction: true,
                              name: "file"
                            },
                            on: {
                              uploadOk: _vm.uploadOk,
                              remove: function($event) {
                                return _vm.removeFile($event, "file7")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("a", { on: { click: _vm.downFile } }, [
                            _vm._v("授权委托书(管理员变更)模板下载")
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c9034f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c9034f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/admin-modify.vue
// module id = shQv
// module chunks = 1